import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import CustomSelect from "../../../../helpers/ui/CustomSelect"

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            flexytimeOptions: [],
            locationOptions: [],
            typeOptions: [
                {
                    label: 'WFO',
                    value: 1
                },
                {
                    label: 'WFH',
                    value: 0
                }
            ]
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function (data) {
            var newObj = {};
            newObj["label"] = data[label];
            newObj["value"] = data[value];

            return newObj;
        });
    };

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.dataForm.working_pattern_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            dataForm: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.flexyTimeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            flexytimeOptions: this.reformatOptions(
                                response.result,
                                'working_flexible_time_value',
                                'working_flexible_time_uuid',
                            )
                        })
                        this.updateBloc.fetchLocation({})
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.locationChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            locationOptions: response.result
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.updateBloc.fetchFlexytime({ limit: 9999 })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Edit Pola Kerja</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="working_pattern_name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Pola <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="working_pattern_name"
                                                    placeholder="Nama Pola..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Pola"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="working_pattern_name"
                                                    value={this.state.dataForm?.working_pattern_name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="working_pattern_name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Flexible Time <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name={`working_pattern_flexible_time_uuid`}
                                                    errorMessage="Pilih Flexible Time"
                                                    options={this.state.flexytimeOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Flexible Time"
                                                    defaultValue={this.state.dataForm?.working_pattern_flexible_time_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="working_pattern_name"
                                                className="col-md-3 col-form-label"
                                            >
                                                Jenis Pola <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <CustomSelect
                                                    name={`working_pattern_type`}
                                                    errorMessage="Pilih Opsi"
                                                    options={this.state.typeOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Opsi"
                                                    defaultValue={this.state.dataForm?.working_pattern_type}
                                                    onChange={(opt) => this.setState({ dataForm: { ...this.state.dataForm, working_pattern_type: opt.value } })}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="working_pattern_presensi_location_uuid"
                                                className="col-md-3 col-form-label"
                                            >
                                                Presensi Lokasi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name={`working_pattern_presensi_location_uuid`}
                                                    errorMessage="Pilih Opsi"
                                                    options={this.state.locationOptions}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Opsi"
                                                    defaultValue={this.state.dataForm?.working_pattern_presensi_location_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        {this.state.dataForm?.working_pattern_type === 0 && (
                                        // {0 === 0 && (
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="working_pattern_wfh_report_limit"
                                                    className="col-md-3 col-form-label"
                                                >
                                                    Batas Pelaporan WFH (Hari) <span className="text-danger">*</span>
                                                </label>
                                                <Col md="3">
                                                    <AvField
                                                        name="working_pattern_wfh_report_limit"
                                                        placeholder="Jumlah hari..."
                                                        type="number"
                                                        errorMessage="Masukkan Batas Pelaporan"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="working_pattern_wfh_report_limit"
                                                        value={this.state.dataForm?.working_pattern_wfh_report_limit}
                                                    />
                                                </Col>
                                            </Row>
                                        )}

                                        {/* <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                    <AvCheckboxGroup name="checkboxExample" errorMessage="Agreement harus di centang">
                                                        <AvCheckbox label="Centang untuk mengaktifkan jam kerja ini dan menonaktifkan jam kerja yang sedang aktif" value="1" />
                                                    </AvCheckboxGroup>
                                                </div>
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                {this.state.redirect ?
                    <Redirect to='/master/pola_kerja.html?' />
                    : null}
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);
